import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * 🔧 FIX 2026-02-26: Service pour gérer le repliage automatique des accordéons répétables
 * Quand un nouvel élément est ajouté à un groupe répétable (comme GR-Lot-AwardCriteria-Criterion),
 * ce service notifie les autres accordéons du même type de se replier.
 */
@Injectable({
  providedIn: 'root'
})
export class EformAccordionService {

  /**
   * Subject qui émet un événement quand les accordéons d'un type donné doivent se replier
   * @param groupType - Le type de groupe (ex: "GR-Lot-AwardCriteria-Criterion")
   * @param exceptId - L'ID de l'accordéon qui ne doit PAS se replier (le nouveau créé)
   */
  private collapseOthersSubject = new Subject<{ groupType: string, exceptId: string }>();
  public collapseOthers$ = this.collapseOthersSubject.asObservable();

  constructor() { }

  /**
   * Notifie tous les accordéons d'un type donné de se replier, sauf celui spécifié
   * @param groupType - Le type de groupe (base de l'ID sans le suffixe numérique)
   * @param exceptId - L'ID de l'accordéon à garder ouvert (généralement le nouveau créé)
   */
  public collapseOthers(groupType: string, exceptId: string): void {
    this.collapseOthersSubject.next({ groupType, exceptId });
  }

  /**
   * Extrait le type de groupe à partir d'un ID d'élément
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   * Ex: "GR-Lot-AwardCriteria-Criterion" -> "GR-Lot-AwardCriteria-Criterion"
   */
  public extractGroupType(elementId: string): string {
    if (!elementId) return '';
    // Trouver le dernier underscore suivi de chiffres
    const match = elementId.match(/^(.+?)(?:_\d+)?$/);
    return match ? match[1] : elementId;
  }
}

